import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Box, Button, debounce, Popover, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import DateRangeFilter from '../DateRangeFilter/DateRangeFilter';
import MultiSelectPopover from '../MultiSelectPopover/MultiSelectPopover';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; // Import the dropdown icon
import { useDispatch, useSelector } from 'react-redux';
import {
  selectChannelKeys,
  selectClientType,
  selectEndDate,
  selectLocationKeys,
  selectSelectedClientConfig,
  selectStartDate,
  selectTimeStamp,
  selectAlertId,
  selectTicketType,
  selectPriority,
  allStoreDetails
} from 'src/app/selectors/filterSelectors';
import {
  selectBrands,
  selectBrandsAsList,
  selectAlerts,
  selectAlertsAsList,
} from 'src/app/selectors/appDataSelectors';
import {
  getActiveUsers,
  getInventoryData,
  getReportsNMSWorker,
  getNmsAlertsZendeskData,
  resetSelectedFilter,
  updateSelectedFilter,
  getNmsLogsData,
} from 'src/slices/filterSlice';
import { formatEndDate, getDateRange } from 'src/utils/DateUtil';
import { useConfig } from 'src/context/ConfigContext';
import { selectReport } from 'src/app/selectors/appDataSelectors';
import { AppConfig } from 'src/config/AppConfig';

// Define styles using makeStyles
const useStyles = makeStyles((theme: Theme) => ({
  filterBar: {
    display: 'flex',
    alignItems: 'end',
    gap: theme.spacing(2),
    padding: 2,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  button: {
    height: '40px',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  formControl: {
    minWidth: 150,
  },
}));

const FilterBar: React.FC = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { config } = useConfig();
  const clientType = useSelector(selectClientType);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const channels = useSelector(selectChannelKeys);
  const locationKeys = useSelector(selectLocationKeys);

  const [selectedRange, setSelectedRange] = useState<string>('Last 7 Days');
  const [showFilterButtons, setshowFilterButtons] = useState<boolean>(false);
  const startDate = useSelector(selectStartDate);
  const alertId = useSelector(selectAlertId);
  const ticketType = useSelector(selectTicketType);
  const priority = useSelector(selectPriority);

  const endDate = useSelector(selectEndDate);
  const timeStamp = useSelector(selectTimeStamp);
  const selectedMenu = useSelector(selectReport);
  const clientConfig = useSelector(selectSelectedClientConfig);

  const allStoreIdDetails = useSelector(allStoreDetails);
  console.log ('STOREIDDETAILS',allStoreIdDetails);
  const isHide =
    selectedMenu === 'admin' ||
    localStorage.getItem('selectedMenu') === 'admin' ||
    selectedMenu === 'users' ||
    localStorage.getItem('selectedMenu') === 'users';

  const [hasInteracted, setHasInteracted] = useState(false);
  const [filterData, setFilterData] = useState('');

  const brands = useSelector(selectBrands);
  const brandsAsList = useSelector(selectBrandsAsList);
  //const ListBrands = brandsAsList.map(brand => brand.name);
  const ListBrands = brandsAsList
    .filter((brand) => brand.live)
    .map((brand) => brand.name);
  const brandkey = brandsAsList
    .filter((brand) => brand.live)
    .map((brand) => brand.bq_concept_name);

  const alertAsList = useSelector(selectAlertsAsList);
  const ListAlerts = alertAsList.map((alert) => alert.alertKey);
  const alertDetails = useSelector(selectAlerts);

  console.log('BRANDS', brands);
  console.log('selecteedmenu', selectedMenu);
  console.log('brandsAsList', brandsAsList);
  console.log('ListBrands', ListBrands);
  console.log('locationKeys', locationKeys);
  console.log('ListAlerts', ListAlerts);
  console.log('AlertDetails', alertDetails);
  console.log('SelectedAlert ID', alertId);

  const [selectedFilters, setSelectedFilters] = useState({
    dateRange: 'Last 7 Days',
    channel: [] as string[],
    //brands: brandkey as string[],
    brands: ['iStore_Swyft'],
    account: brandkey as string[],
    //store: locationKeys as string[],
    store: [] as string[],
    ticketType: '',
    priority: '',
    alertId: [] as string[],
  });

  console.log("SELECTED BRANDS",selectedFilters.brands)
  // Use the styles created
  const classes = useStyles();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleApplyDateRange = (
    startDate: Date,
    endDate: Date,
    timeStamp: string,
    range: string,
  ) => {
    console.log('---range-', range);
    setSelectedRange(
      range.includes('CUSTOM')
        ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
        : range,
    );
    dispatch(
      updateSelectedFilter({
        key: 'timeStamp',
        value: timeStamp,
      }),
    );
    dispatch(
      updateSelectedFilter({
        key: 'start',
        value: formatEndDate(startDate),
      }),
    );
    dispatch(
      updateSelectedFilter({
        key: 'end',
        value: formatEndDate(endDate),
      }),
    );
    handleClose();
  };

  const open = Boolean(anchorEl);
  const updateFilter = useCallback(
    debounce((key: string, value: string[]) => {
      dispatch(
        updateSelectedFilter({ key, value: value ? value.join(',') : '' }),
      );
    }, 300),
    [],
  );
  const handleSelectChange = (
    key: keyof typeof selectedFilters,
    data: string[],
  ) => {
    setSelectedFilters((prev) => ({ ...prev, [key]: data }));
    updateFilter(key, data);
    if (hasInteracted && data.length > 0) setFilterData(filterData + key);
    else setFilterData(filterData.replace(key, ''));
  };
  useEffect(() => {
    if (filterData.length > 0 && hasInteracted)
      setshowFilterButtons(true); // Set to true if filters have changed
    else if (filterData.length == 0 && hasInteracted)
      setshowFilterButtons(false);
  }, [selectedFilters, hasInteracted]);

  const handleApply = () => {
    // This function will call the API once the startDate and endDate have been updated in Redux
    if (!config) {
      console.error('no Config loaded');
      return;
    }
    if (startDate && endDate) {
      // Your API call here
      console.log(
        'Calling API with updated date range:',
        startDate,
        endDate,
        config,
      );
      const headers = {
        Authorization: config['HEADER']['Authorization'],
      };

      if (selectedMenu === 'NMS-Alert-Zendesk') {
        dispatch(
          getNmsAlertsZendeskData({
            // url: config.API_URL.nmsalerts_zendesk,
            url: config.API_URL.nmsalerts_zendesk_logs,
            headers,
            page: 1,
            selectedMenu: selectedMenu,
          }),
        );
      } else if (selectedMenu === 'NMS-Worker-Logs') {
        dispatch(
          getReportsNMSWorker({
            //UPDATE THE CORRECT API_URL for nms worker logs here
            url: config.API_URL.nms_workerlogs,
            //url: config.API_URL.nms_workerlogs_demo,
            headers,
            page: 1,
            selectedMenu: selectedMenu,
          }),
        );
      } else if (selectedMenu === 'Alert-Rules') {
        dispatch(
          getNmsLogsData({
            url: config.API_URL.nms_logs,
            headers,
            page: 1,
            selectedMenu: selectedMenu,
          }),
        );
      } else if (selectedMenu === 'users' || selectedMenu === 'admin') {
        //store_status
        dispatch(getActiveUsers({ selectedMenu: selectedMenu }));
      }
    }
  };

  useEffect(() => {
    // Check when the startDate and endDate in Redux have been updated, then call the API
    console.log(' API with updated:', startDate, endDate, selectedMenu);
    if (startDate && endDate && selectedMenu) {
      handleApply(); // Call API only when dates are updated
    }
  }, [startDate, endDate, selectedMenu, config, clientConfig]);

  useEffect(() => {
    const { startDate, endDate } = getDateRange('last 7 days');
    dispatch(updateSelectedFilter({ key: 'start', value: startDate }));
    dispatch(
      updateSelectedFilter({
        key: 'end',
        value: endDate + 'T23:59:59',
      }),
    );
    dispatch(
      updateSelectedFilter({
        key: 'report',
        value: selectedMenu || 'NMS-Alert-Zendesk',
      }),
    );
    dispatch(updateSelectedFilter({ key: 'store', value: '' }));
  }, []);

  const handleReset = () => {
    const { startDate, endDate } = getDateRange('last 7 days');
  
    setSelectedFilters({
      dateRange: 'Last 7 Days',
      channel: [],
      brands: ['iStore_Swyft'],
      account: [],
      store: [],
      ticketType: '',
      priority: '',
      alertId: [],
    });
    setshowFilterButtons(false);
    setHasInteracted(false);
    dispatch(resetSelectedFilter());
  
    dispatch(updateSelectedFilter({ key: 'start', value: startDate }));
    dispatch(updateSelectedFilter({ key: 'end', value: endDate + 'T23:59:59' }));
  
    // If needed, also re-apply report filter
    dispatch(
      updateSelectedFilter({
        key: 'report',
        value: selectedMenu || 'NMS-Alert-Zendesk',
      }),
    );
  
    // Call API again after resetting filters
    handleApply();
  };  

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // month is zero-indexed
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  return (
    <>
      {isHide ? (
        <></>
      ) : (
        <Box className={classes.filterBar} sx={{ fontSize: '.9rem' }}>
          <Button
            onClick={handleClick}
            variant="outlined"
            className={classes.button}
            color={theme.palette.primary.contrastText}
            endIcon={<ExpandMoreIcon className={open ? 'rotate-180' : ''} />}
            sx={{ textTransform: 'capitalize' }}
          >
            {selectedRange}
          </Button>

          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <DateRangeFilter
              onApply={handleApplyDateRange}
              timeStamp={timeStamp || 'storeLocal'}
            />
          </Popover>

          {(selectedMenu === 'NMS-Alert-Zendesk' ||
            selectedMenu === 'Alert-Rules' || selectedMenu === 'NMS-Worker-Logs') && (
            <Box>
              Brand Name
              <MultiSelectPopover
                //options={ListBrands}
                options={brandkey}
                label="Search"
                buttonLabel={
                  <span style={{ textTransform: 'capitalize' }}>
                    {selectedFilters.brands.length
                      ? selectedFilters.brands.join(', ')
                      : 'All'}
                  </span>
                }
                isMultiSelect={true}
                selectedOptions={selectedFilters.brands}
                onSelectChange={(data) =>
                  //change to brands and see here
                  handleSelectChange('brands', data as string[])
                }
                handleMultiClick={() => setHasInteracted(true)}
                onApply={handleApply}
              />
            </Box>
          )}

          {selectedMenu === 'NMS-Alert-Zendesk' && (
            <Box>
              Store Id
              <MultiSelectPopover
                //options={locationKeys}
                options={allStoreIdDetails
                  .filter((item) => selectedFilters.brands.includes(item.concept_name))
                  .map((item) => item.estation_name)}
                label="Search"
                buttonLabel={
                  <span style={{ textTransform: 'capitalize' }}>
                    {selectedFilters.store.length
                      ? selectedFilters.store.join(', ')
                      : 'All'}
                  </span>
                }
                isMultiSelect={true}
                selectedOptions={selectedFilters.store}
                onSelectChange={(data) =>
                  handleSelectChange('store', data as string[])
                }
                handleMultiClick={() => setHasInteracted(true)}
                onApply={handleApply}
              />
            </Box>
          )}

          {(selectedMenu === 'NMS-Alert-Zendesk' ||
            selectedMenu === 'Alert-Rules') && (
            <Box>
              Alert Id
              <MultiSelectPopover
                //options={alertId}
                options={ListAlerts}
                label="Search"
                buttonLabel={
                  <span style={{ textTransform: 'capitalize' }}>
                    {selectedFilters.alertId?.length
                      ? selectedFilters.alertId.join(', ')
                      : 'All'}
                  </span>
                }
                isMultiSelect={true}
                selectedOptions={selectedFilters.alertId || []}
                onSelectChange={(data) =>
                  handleSelectChange('alertId', data as string[])
                }
                handleMultiClick={() => setHasInteracted(true)}
                onApply={handleApply}
              />
            </Box>
          )}

          {selectedMenu === 'NMS-Alert-Zendesk' &&
            AppConfig.ticketType.length > 0 && (
              <Box>
                Ticket Type
                <MultiSelectPopover
                  options={AppConfig.ticketType}
                  label="Search"
                  buttonLabel={
                    <span style={{ textTransform: 'capitalize' }}>
                      {selectedFilters.ticketType?.length
                        ? selectedFilters.ticketType.join(', ')
                        : 'All'}
                    </span>
                  }
                  isMultiSelect={true}
                  selectedOptions={selectedFilters.ticketType || []}
                  onSelectChange={(data) =>
                    handleSelectChange('ticketType', data as string[])
                  }
                  handleMultiClick={() => setHasInteracted(true)}
                  onApply={handleApply}
                />
              </Box>
            )}

          {selectedMenu === 'NMS-Alert-Zendesk' &&
            AppConfig.ticketPriority.length > 0 && (
              <Box>
                Priority
                <MultiSelectPopover
                  options={AppConfig.ticketPriority}
                  label="Search"
                  buttonLabel={
                    <span style={{ textTransform: 'capitalize' }}>
                      {selectedFilters.priority?.length
                        ? selectedFilters.priority.join(', ')
                        : 'All'}
                    </span>
                  }
                  isMultiSelect={true}
                  selectedOptions={selectedFilters.priority || []}
                  onSelectChange={(data) =>
                    handleSelectChange('priority', data as string[])
                  }
                  handleMultiClick={() => setHasInteracted(true)}
                  onApply={handleApply}
                />
              </Box>
            )}

          {showFilterButtons && (
            <>
              <Button
                onClick={handleApply}
                variant="contained"
                className={classes.button}
              >
                Apply
              </Button>

              <Button
                onClick={handleReset}
                variant="outlined"
                className={classes.button}
              >
                Reset
              </Button>
            </>
          )}
          <Box
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '60%',
            }}
          >
            <div style={{ fontSize: '12px' }}>
              {'Data Last Updated: '} {getCurrentDateTime()}
            </div>
          </Box>
        </Box>
      )}
    </>
  );
};

export default FilterBar;
